export enum ApplicationTypeEnum {
    PublicSafety = 1,
    IndustrialBusiness = 2,
}

export const ApplicationTypeLabelMapping: Record<ApplicationTypeEnum, string> =
    {
        [ApplicationTypeEnum.PublicSafety]: 'PS',
        [ApplicationTypeEnum.IndustrialBusiness]: 'I/B',
    } as const;
